import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { sizing, typography } from '@statsbomb/kitbag-themes';

var PAGINATION_SIZE = {
  REGULAR: 'regular',
  SMALL: 'small'
};
var PAGINATION_LABEL_POSITION = {
  LEFT: 'left',
  RIGHT: 'right'
};
var PAGINATION_ALIGNMENT = {
  LEFT: 'left',
  RIGHT: 'right'
};
var PAGINATION_GAP = _defineProperty(_defineProperty({}, PAGINATION_SIZE.SMALL, sizing.huge), PAGINATION_SIZE.REGULAR, sizing.small);
var PAGINATION_LABEL_TYPOGRAPHY = _defineProperty(_defineProperty({}, PAGINATION_SIZE.SMALL, typography.bodyMedium), PAGINATION_SIZE.REGULAR, typography.bodyRegular);
var PAGINATION_BUTTON_GROUP_MIN_WIDTH = _defineProperty(_defineProperty({}, PAGINATION_SIZE.SMALL, 24), PAGINATION_SIZE.REGULAR, 32);
var PAGINATION_FIXED_BUTTON_STYLING = _defineProperty(_defineProperty({}, PAGINATION_SIZE.SMALL, "\n    width: 1.5rem;\n    padding: ".concat(sizing.xtiny, " 0;\n  ")), PAGINATION_SIZE.REGULAR, "\n    width: 2rem;\n    padding: 0.1875rem 0;\n  ");
var PAGINATION_BUTTON_SIZES = _defineProperty(_defineProperty({}, PAGINATION_SIZE.SMALL, [24, 32, 40, 48]), PAGINATION_SIZE.REGULAR, [32, 40, 48, 56]);
var PAGINATION_MIN_WIDTH_THAT_SUPPORTS_EDGE_BUTTONS = _defineProperty(_defineProperty({}, PAGINATION_SIZE.SMALL, 144), PAGINATION_SIZE.REGULAR, 192);

export { PAGINATION_ALIGNMENT, PAGINATION_BUTTON_GROUP_MIN_WIDTH, PAGINATION_BUTTON_SIZES, PAGINATION_FIXED_BUTTON_STYLING, PAGINATION_GAP, PAGINATION_LABEL_POSITION, PAGINATION_LABEL_TYPOGRAPHY, PAGINATION_MIN_WIDTH_THAT_SUPPORTS_EDGE_BUTTONS, PAGINATION_SIZE };
//# sourceMappingURL=Pagination.constants.js.map
